import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { ManagementScheduleExecutionService } from '@core/services/entities/management-schedule-execution.service';
import { ListManagementScheduleExecutionRequestDto } from '@domain/management-schedule-execution/dtos/list-management-schedule-execution.request.dto';
import { ManagementScheduleExecutionResponseDto } from '@domain/management-schedule-execution/dtos/management-schedule-execution.response.dto';
import { ManagementScheduleExecutionRepository } from '@domain/management-schedule-execution/repositories/management-schedule-execution.repository';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ManagementScheduleExecutionRepositoryService implements ManagementScheduleExecutionRepository {
  constructor(
    private managementScheduleExecutionService: ManagementScheduleExecutionService,
  ) {}

  list(
    request: ListManagementScheduleExecutionRequestDto,
  ): Observable<
    ApiResponse<PageableResponse<ManagementScheduleExecutionResponseDto>>
  > {
    return this.managementScheduleExecutionService.list(request);
  }
}
